export default "__VITE_ASSET__CNsPERCV__"